import { useEffect } from "react";
import posthog from "posthog-js";

interface PostHogProviderProps {
  children: React.ReactNode;
  apiKey: string;
  apiHost?: string;
}

export const initPostHog = (apiKey: string, apiHost?: string) => {
  if (typeof window !== "undefined" && apiKey && apiKey !== "XXXX") {
    posthog.init(apiKey, {
      api_host: apiHost || "https://us.i.posthog.com",
      person_profiles: "identified_only",
      capture_pageview: true,
      capture_pageleave: true,
    });
  }
};

export const PostHogProvider = ({
  children,
  apiKey,
  apiHost,
}: PostHogProviderProps) => {
  useEffect(() => {
    initPostHog(apiKey, apiHost);
  }, [apiKey, apiHost]);

  return <>{children}</>;
};

// Helper functions to interact with PostHog
export const identifyUser = (
  userId: string,
  properties?: Record<string, any>
) => {
  posthog.identify(userId, properties);
};

export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  posthog.capture(eventName, properties);
};

export const resetUser = () => {
  posthog.reset();
};

// Re-export posthog for direct access if needed
export { posthog };















